<script>
  import { onMount, afterUpdate } from "svelte";

  import SocialTags from "@Components/SocialTags/index.svelte";
  import MainMenu from "@Components/MainMenu/index.svelte";

  import RegistrationForm from "@Pages/SignUp/content.svelte";

  import FeaturedImage from "@Components/FeaturedImage/index.svelte";
  import Pricing from "@Components/Pricing/index.svelte";
  import Banner from "@Components/Banner/index.svelte";

  import FooterMenu from "@Components/FooterMenu/index.svelte";
  import CopyrightFooter from "@Components/CopyrightFooter/index.svelte";

  import { AWSAuth, Navigation, Utils, AWSAnalytics } from "@Services";

  export let router = null;
  let isAnonymous = true;

  const DEBUG = document.location.protocol === "http:" ? true : false;

  let togglePages = event => {
    Navigation.goTo(event.detail.item);
  };

  afterUpdate(() => {
    AWSAuth.isAnonymous().then(user => {
      isAnonymous = user;
    });
  });

  onMount(async () => {
    console.info("App " + DEBUG + "::" + router.path);

    mobiscroll.settings = {
      theme: "d-ns",
      themeVariant: "light",
      lang: "es"
    };

    mobiscroll.page(".signup-page", {});

    Utils.scrollToTop();
  });
</script>

<style src="./style.scss">

</style>

<SocialTags
  pageTitle="Regístrate"
  pageDesc="Tu membresía te da acceso a todas las sesiones de todas las
  disciplinas."
  urlPath="/signup/" />
<main id="dnsPageSignup" class="mbsc-grid d-ns-page signup-page">
  <nav>
    <MainMenu
      on:menuTapped={togglePages}
      selectedItem="signup"
      path={router.path} />
  </nav>

  <FeaturedImage
    title="Disfruta siete días"
    subtitle="con accceso a todas las clases sin restricciones."
    featured="/images/background-02.jpg"
    fullScreenClass="fullscreen-image" />

  {#if !isAnonymous}
    <Pricing />
  {:else}
    <RegistrationForm />
  {/if}

  <Banner
    title="Nuevas sesiones cada semana"
    description="No importa si estás aquí porque quieres aprender una nueva
    disciplina, o eres un instructor avanzado que busca hacer crecer su
    repertorio. Cada semana agregaremos cuatro sesiones nuevas para ayudarte a
    lograr tus objetivos."
    image="/images/d-ns-home.jpg" />

  <footer class="mbsc-row">
    <nav class="mbsc-col-12">
      <FooterMenu />
    </nav>
    <CopyrightFooter />
  </footer>
</main>
